export const home = {
  // Hero Section
  heroSubtitle: '진지한 학습자를 위한 고품질 1:1 언어 교환',
  heroTitle: 'Maximize the Quality',
  heroTitleHighlight: 'of Language Exchange',
  heroDescription: 'EachTeach는 온라인상에서 워크시트를 따라 원어민과의 언어 학습 기회를 제공하는 플랫폼입니다. 유료이자 1:1 언어 교환은 치안과 안전을 보장하는 학습 환경을 만들어냅니다. 자신의 학습 언어 레벨에 맞는 파트너와 매칭함으로써 대화는 도전적이면서도 고밀도 학습이 됩니다. 실수해도 괜찮습니다. 자신에게 도전할 기회가 많은 환경이 언어 학습의 효율을 극적으로 향상시킵니다.',
  getStarted: '지금 등록하기',
  learnMore: '코스 흐름 보기',
  
  // Features
  feature1Title: '안전한 유료 시스템',
  feature1Description: '원치 않는 교류를 완전히 회피. 진지한 학습자만 모이는 환경.',
  feature2Title: '최적의 매칭',
  feature2Description: '다른 학습 레벨의 파트너와 페어링. 성장을 가속화하는 최적의 스트레스 레벨.',
  feature3Title: '극적인 효율 향상',
  feature3Description: '목표 언어로 모국어를 설명할 기회가 많아 실용적인 스킬이 빠르게 향상.',
  
  // Lesson Content Section
  lessonContentTitle: '레슨 내용',
  lessonContentSubtitle: '효율적인 학습을 지원하는 충실한 레슨 환경',
  
  freeTrial: '첫 2회 무료',
  freeTrialDescription: '레슨 전후 설문조사에 답하기만 하면 처음 2회 레슨을 무료로 수강할 수 있습니다!',
  
  googleMeetTitle: 'Google Meet로 온라인 레슨',
  googleMeetDescription: '장소에 구애받지 않고 편안한 환경에서 레슨을 수강할 수 있습니다.',
  
  worksheetTitle: '신중하게 설계된 워크시트',
  worksheetDescription: '대화 보조 및 학습 효율 유지를 목적으로 설계된 워크시트를 따라 레슨을 진행합니다. 전용하지 않는다면 작성하거나 인쇄해도 OK! 자신의 학습에 도움이 되도록 사용하세요.',
  
  communicationTitle: '진정한 커뮤니케이션 능력',
  communicationDescription: '레슨 중에는 번역이나 AI, 채팅 기능을 활용하는 등 커뮤니케이션을 위한 노력이 실제 대화에서 살아나는 것을 느껴보세요. 서로 다가가는 진정한 커뮤니케이션 능력을 키웁니다.',
  
  // Flow Steps
  flowStep1: 'Google Meet\n연결',
  flowStep2: '워크시트\n따라 진행',
  flowStep3: '번역·AI 활용\n커뮤니케이션',
  flowStep4: '실용적 스킬\n향상',
  
  // Pricing Section
  pricingTitle: '가격 플랜',
  pricingSubtitle: '학습 언어와 국적에 따라 가격이 다릅니다. 추가 레슨은 정규 레슨 가격의 1.2배입니다.',
  
  regularLessons: '정규 레슨 (레벨 A~C)',
  englishLearning: '영어 학습',
  forJapanese: '일본인 대상',
  forKorean: '한국인 대상',
  japaneseKoreanLearning: '일본어/한국어 학습',
  allLearners: '모든 학습자',
  perLesson: '레슨당 (90분)',
  
  additionalLessons: '추가 레슨 (어드밴스 코스)',
  englishLearningJapanese: '영어 학습 (일본인)',
  englishLearningKorean: '영어 학습 (한국인)',
  additionalLessonsNote: '추가 레슨은 정규 레슨 (레벨 A~C) 완료 후 수강 가능합니다.',
  
  extraLessonsTitle: '엑스트라 레슨 (레벨 진급)',
  extraLessonsDescription: '각 레벨로 진급할 때 1회의 테스트와 2회의 보강 레슨으로 구성된 엑스트라 레슨 세트를 수강합니다. 가격은 정규 레슨 3회분에 해당합니다.'
};
